<template>
<svg viewBox="0 0 49 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-server-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.017 35.552c.52 0 .976.343 1.121.842l1.31 4.496a1.314 1.314 0 01-1.262 1.681H5.813a1.314 1.314 0 01-1.262-1.68l1.31-4.497a1.168 1.168 0 011.12-.842h35.036zM38.222 5.43a4.672 4.672 0 014.672 4.671v21.945c0 .645-.523 1.168-1.168 1.168H7.273a1.168 1.168 0 01-1.167-1.168V10.1a4.672 4.672 0 014.671-4.671h27.445zm-13.238 7.896c-2.377 0-4.42 1.393-5.32 3.387l-.164.407-.325-.014c-2.139 0-3.873 1.692-3.873 3.78 0 1.964 1.536 3.58 3.5 3.762l.373.018h11.23l-.003-.006.184-.005c1.741-.138 3.11-1.561 3.11-3.297 0-1.693-1.303-3.089-2.98-3.283-.45-2.693-2.846-4.749-5.732-4.749z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudServerFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
